import React from "react";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { truncateText } from "../../../../utils/string-helpers";
import PropTypes from "prop-types";

export const ParticipantCard = React.memo(
  ({ participant, handleParticipantAction, webAppTheme }) => {
    const {
      _id,
      name = "",
      avatar = {},
      role,
      isGuest,
      isBlocked,
      isRegistered,
    } = participant;
    return (
      <div className="edit-channel-cards" key={_id}>
        <div className="edit-channels-info-container">
          <div
            className={"avatar-group-chat avatar-group-chat-border"}
            style={{
              background: `url(${getAvatarUrl(
                { avatar },
                false,
                webAppTheme
              )})`,
              backgroundPosition: "center center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="identifier-group-chat">
            <span className="name-group-chat">{truncateText(name)}</span>
            <span className="role-group-chat">{role}</span>
          </div>
        </div>
        {role === "Subscriber" && (
          <div className="make-block-actions">
            <button
              disabled={isBlocked || !isRegistered}
              type="button"
              className={
                isGuest
                  ? "admin-button-actions"
                  : "admin-button-actions admin-button-actions-danger"
              }
              onClick={() =>
                handleParticipantAction(
                  isGuest ? "make-admin" : "revoke-admin",
                  _id
                )
              }
            >
              {isGuest ? "Make group admin" : "Revoke group admin"}
            </button>

            <button
              disabled={!isGuest}
              className={
                isBlocked
                  ? "block-button-actions"
                  : "block-button-actions admin-button-actions-danger"
              }
              onClick={() =>
                handleParticipantAction(
                  isBlocked ? "unblock-participant" : "block-participant",
                  _id
                )
              }
              type="button"
            >
              <span>{isBlocked ? "Unblock" : "Block"}</span>
            </button>
          </div>
        )}
      </div>
    );
  }
);

ParticipantCard.propTypes = {
  participant: PropTypes.object,
  handleParticipantAction: PropTypes.func,
  webAppTheme: PropTypes.string,
};
